import {Component, OnInit} from '@angular/core';

import {BasicHistoryListItemModel} from '../../../../models/basic-history-list-item.model';
import {BasicHistoryListModel} from '../../../../models/basic-history-list.model';
import {IProjectService} from '../../../../services/project.service.interface';
import {ChangeHistoryBasicTypeEnum} from '../../../../enums/change-history-basic-type.enum';
import {ModalDialogV3} from '../../../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-project-history-table-modal',
    templateUrl: './project-history-table-modal.component.html',
    styleUrls: ['./project-history-table-modal.component.scss']
})

export class ProjectHistoryTableModalComponent extends ModalDialogV3 implements OnInit {


    public model = { basicHistory: [] as BasicHistoryListItemModel[] };

    public changeHistoryBasicTypeEnum = ChangeHistoryBasicTypeEnum;

    constructor(private projectService: IProjectService,
    ) {
        super();
    }

    public async ngOnInit() {
        // PPU_log console.log('this.modalParams.model.projectId', (<{ projectId: number }>this.modalParams.model).projectId);
        const projectId = this.modalParams.model['projectId'];
        const basicHistoryListModel: BasicHistoryListModel = await this.projectService.getProjectBasicHistory(projectId);
        this.model.basicHistory = basicHistoryListModel.basicHistory;
    }

    onCancelBtnClicked() {
        super.close();
    }


}
